import React from "react";
import { SimpleGrid, Box, Text, VStack, HStack } from "@chakra-ui/react";
import { formatBytes, formatDuration } from "./format";

function Ranked({ title, rows, label, sub }) {
  const max = Math.max(1, ...rows.map((r) => r.rss_delta_mb || 0));
  return (
    <Box borderWidth={1} borderRadius="md" p={3} bg="white">
      <Text fontWeight="semibold" fontSize="sm" mb={2}>{title}</Text>
      {rows.length === 0 && <Text fontSize="sm" color="gray.500">Nothing recorded in this window.</Text>}
      <VStack align="stretch" spacing={2}>
        {rows.map((r, i) => (
          <Box key={`${label(r)}-${i}`}>
            <HStack justify="space-between" fontSize="sm">
              <Text noOfLines={1} title={label(r)}>{label(r)}</Text>
              <Text fontWeight="semibold" whiteSpace="nowrap">+{Math.round(r.rss_delta_mb || 0)} MB</Text>
            </HStack>
            <Box h="6px" bg="gray.100" borderRadius="full" overflow="hidden">
              <Box h="6px" bg="purple.400" w={`${Math.round(((r.rss_delta_mb || 0) / max) * 100)}%`} />
            </Box>
            <Text fontSize="xs" color="gray.500">{sub(r)}</Text>
          </Box>
        ))}
      </VStack>
    </Box>
  );
}

const KIND_LABELS = { room: "document held in memory", file: "uploaded or faxed file", patient: "patient AI cache" };

export default function ContributorsPanel({ contributors }) {
  const c = contributors || { users: [], endpoints: [], resources: [] };
  return (
    <Box>
    <Text fontSize="xs" color="gray.500" mb={2}>
      Ranked by how much server memory grew while each one's requests ran. Overlapping requests share the same growth, so read these as leads, not exact blame.
    </Text>
    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3}>
      <Ranked
        title="By user"
        rows={c.users || []}
        label={(r) => r.name || r.email || r.user_id}
        sub={(r) => `${r.requests} requests · ${formatDuration(r.heavy_ms)} spent in slow requests · ${formatBytes(r.bytes)} transferred`}
      />
      <Ranked
        title="By backend action"
        rows={c.endpoints || []}
        label={(r) => r.path}
        sub={(r) => `${r.requests} calls · ${formatDuration(r.avg_ms)} each on average · ${formatBytes(r.bytes)} transferred`}
      />
      <Ranked
        title="By file or document"
        rows={c.resources || []}
        label={(r) => r.key}
        sub={(r) => `${KIND_LABELS[r.kind] || r.kind} · loaded ${r.hits} time${r.hits === 1 ? "" : "s"} · ${formatBytes(r.bytes)} · ${(r.users || []).length} user${(r.users || []).length === 1 ? "" : "s"}`}
      />
    </SimpleGrid>
    </Box>
  );
}
